import React from 'react';
import { string, shape } from 'prop-types';
import styles from './MemberProfileCard.module.scss';
import HeadlineSmall from '../HeadlineSmall';
import DefaultLink from '../../typeface/DefaultLink';
import DefaultParagraph from '../../typeface/DefaultParagraph';

const MemberProfileCard = ({
  source,
  bgSource,
  role,
  name,
  phone,
  mail,
  desc,
}) => (
  <div className={styles.containerMain}>
    <div
      style={{ backgroundImage: `url('${bgSource.main}'), url('${bgSource.fall}')` }}
      className={styles.containerBackground}
    >
      <div className={styles.containerTextBackground}>
        <div
          className={styles.containerLink}
          style={{ justifyContent: phone ? 'space-between' : 'center' }}
        >
          <DefaultLink href={`mailto:${mail}`}>
            <DefaultParagraph small>{mail}</DefaultParagraph>
          </DefaultLink>
          <DefaultLink href={`tel:${phone}}`}>
            <DefaultParagraph small>{phone}</DefaultParagraph>
          </DefaultLink>
        </div>
        <p className={styles.textDesc}>{desc}</p>
      </div>
    </div>
    <div
      className={styles.container}
      style={{ backgroundImage: `url('${source.main}'), url('${source.fall}')` }}
    >
      <div className={styles.containerInnerFront}>
        <HeadlineSmall>{role}</HeadlineSmall>
        <h4 className={styles.title}>{name}</h4>
      </div>
    </div>
  </div>
);

MemberProfileCard.propTypes = {
  source: shape({
    main: string,
    fall: string,
  }),
  bgSource: shape({
    main: string,
    fall: string,
  }),
  role: string,
  name: string,
  mail: string,
  phone: string,
  desc: string,
};

MemberProfileCard.defaultProps = {
  source: null,
  bgSource: null,
  role: null,
  name: null,
  mail: null,
  phone: null,
  desc: null,
};

export default MemberProfileCard;
